<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <KeyValueForm @submit-requested="submitRequested"></KeyValueForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import KeyValueForm from './KeyValueForm.vue'

export default {
  components: { KeyValueForm },
  methods: {
    ...mapActions('keyValues', ['postKeyValue']),
    submitRequested (input) {
      this.postKeyValue(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style>
